import { useEffect, useRef } from 'react';

/**
 * Calls `fn` every `intervalMs` while the tab is visible, and once right away
 * when the tab becomes visible again. Used to keep admin/partner views in sync
 * without a manual page refresh.
 */
export default function usePolling(fn, intervalMs = 20000, enabled = true) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    if (!enabled) return undefined;
    const tick = () => { if (!document.hidden) fnRef.current(); };
    const id = setInterval(tick, intervalMs);
    document.addEventListener('visibilitychange', tick);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [intervalMs, enabled]);
}
